import { Stack, useCheckboxState } from '@vtex/admin-ui'
import { Select, useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { Attributes, DefaultProps, Restrictions } from 'typings'
import { CollapsibleCheckbox } from '../../../../CollapsibleCheckbox'
import { IntegerInput } from '../../../../IntegerInput'
import {
  RestrictionElementProps,
  RestrictionFieldProps,
} from '../../hooks/useRestrictions.constate'
import { ApplyTo } from '../../typings'
import { RestrictionsRegister } from '../Component.register'
import { messages } from '../messages'
import { styles } from './styles'
import { ApplyToField } from '../applyToField'

export const MaxItemsPerAttribute = (props: RestrictionFieldProps) =>
  RestrictionsRegister({ Element: MaxItemsPerAttributeEditor, props })

const EMPTY_CONFIG: Restrictions['maxItemsPerAttribute'] = Object.freeze({
  value: 1,
  attribute: Attributes.CART,
  applyTo: ApplyTo.cheapest,
})

export function MaxItemsPerAttributeEditor(
  props: RestrictionElementProps & DefaultProps
) {
  const { name, form } = props

  const { $t } = useIntl()

  const maxItems: Restrictions['maxItemsPerAttribute'] = useWatch({
    form,
    name,
  })

  const handleChange = ({ target: { checked } }) => {
    if (!checked) {
      form.resetField(name)
      form.setValue(name, undefined)
    } else {
      form.setValue(name, { ...EMPTY_CONFIG })
    }
  }

  const state = useCheckboxState({ initialValue: maxItems !== undefined })

  return (
    <CollapsibleCheckbox
      state={state}
      label={$t(messages.maxItemsPerAttribute.label)}
      onChange={handleChange}
    >
      <Stack space="$space-5" fluid>
        <div className={styles.flex}>
          <IntegerInput
            name={`${name}.value`}
            state={form}
            min={1}
            aria-label={$t(messages.maxItemsPerAttribute.ariaLabel)}
          />
          <Select name={`${name}.attribute`} state={form}>
            {Object.values(Attributes).map((attribute) => (
              <option key={attribute} value={attribute}>
                {$t(messages.maxItemsPerAttribute.attribute, {
                  attribute,
                  value: maxItems?.value,
                })}
              </option>
            ))}
          </Select>
        </div>
        <ApplyToField name={`${name}.applyTo`} form={form} />
      </Stack>
    </CollapsibleCheckbox>
  )
}
